import { Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import videoUploadCancel from "../../../../assets/images/upload/uploadCancel.svg";
import "./videoSavedSuccessfully.scss";
import { USER_LIST } from "../../../../routes/routerPath";
import { searchParams } from "../../../../utlis/helpers";
import { pageLocale } from "../../../../utlis/locale";

const VideoCancel = ({ styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  const romPageStatus = sessionStorage.getItem("romStatus");
  const { cancel_upload, done } = pageLocale("videoUpload");
  const navigate = useNavigate();
  const cancelHandler = () => {
    if (romPageStatus === "enter" || romPageStatus === "success") {
      navigate(0);
    } else {
      navigate(USER_LIST + `${searchParams}`);
    }
  };
  return (
    <div className="video-saved-success-main-wrapper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <Paper elevation={3} className={`video-saved-success-wrapper`}>
        <img
          src={videoUploadCancel}
          alt="filesave"
          className="video-save-img"
        />
        <Typography className="saved-text">{cancel_upload}</Typography>
        <button onClick={() => cancelHandler()} className="common-btn">
          {done}
        </button>
      </Paper>
    </div>
  );
};

export default VideoCancel;
